import ClassChooser from './ClassChooser';

export default ClassChooser;
export { ClassChooser };
